import React from "react"
import { Link } from "react-router-dom"
import { size, map } from "lodash"

const Label = cell => {
    return cell.value ? cell.value : "-"
}

const Description = cell => {
    return cell.value ? (
        <div>
            {cell.value.length > 100
                ? cell.value.substring(0, 100) + "..."
                : cell.value}
        </div>
    ) : (
        "-"
    )
}

const BrandName = cell => {
    return cell.value && cell.value.name ? cell.value.name : "-"
}

const UserCashback = cell => {
    return cell.value ? `${cell.value}%` : "0%"
}

const MerchantSettlement = cell => {
    return cell.value ? `${cell.value}%` : "0%"
}

const MaxCashback = cell => {
    const { currency, maxCashbackAmount } = cell.row.original
    return maxCashbackAmount && currency
        ? `${currency.isoCode} ${maxCashbackAmount}`
        : "-"
}

const MinInvoice = cell => {
    const { currency, minInvoiceAmount } = cell.row.original
    return minInvoiceAmount && currency
        ? `${currency.isoCode} ${minInvoiceAmount}`
        : "-"
}

const Tags = cell => {
    return (
        <>
            {map(
                cell.value,
                (tag, index) =>
                    index < 2 && (
                        <Link
                            to="#"
                            className="badge badge-soft-primary font-size-11 m-1"
                            key={"_tag_" + cell.value + index}
                        >
                            {tag}
                        </Link>
                    )
            )}
            {size(cell.value) > 2 && (
                <Link
                    to="#"
                    className="badge badge-soft-primary font-size-11 m-1"
                    key={"_tag_" + cell.value}
                >
                    {size(cell.value) - 2} + more
                </Link>
            )}
        </>
    )
}

const State = cell => {
    return cell.value ? cell.value : "-"
}

const Status = cell => {
    return cell.value ? cell.value : "-"
}

const ValidityDays = cell => {
    return cell.value && Array.isArray(cell.value) ? (
        <div>
            {cell.value.length > 3
                ? `${cell.value.slice(0, 3).join(", ")}...`
                : cell.value.join(", ")}
        </div>
    ) : (
        "-"
    )
}

const MerchantName = cell => {
    const merchant = cell.row.original.merchant
    return merchant?.displayName || merchant?.legalEntityName || "-"
}

const MerchantLocation = cell => {
    const merchant = cell.row.original.merchant
    const location = merchant?.legalEntityAddress || ""
    const city = merchant?.city?.name || ""

    if (!location && !city) {
        return "-"
    }

    return (
        <div>
            <span title={`${location}${city ? `, ${city}` : ""}`}>
                {location}{city ? `, ${city}` : ""}
            </span>
        </div>
    )
}

export {
    Label,
    Description,
    BrandName,
    UserCashback,
    MerchantSettlement,
    MaxCashback,
    MinInvoice,
    Tags,
    State,
    Status,
    ValidityDays,
    MerchantName,
    MerchantLocation
}